import { Link } from "react-router-dom";

const AccessDenied = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full bg-white p-8 rounded-3xl shadow-lg border border-gray-200 text-center">
        <div className="flex justify-center items-center mb-6">
          <h1 className="text-4xl font-bold">
            <Link
              className="flex items-center gap-2 group transition-all duration-300"
              to="/"
            >
              <h1 className="text-2xl font-extrabold tracking-tight">
                H
                <span className="text-[#4d9041] group-hover:text-[#62a556]">
                  A
                </span>
                L
                <span className="text-[#4d9041] group-hover:text-[#62a556]">
                  I
                </span>
                S
                <span className="text-[#4d9041] group-hover:text-[#62a556]">
                  A
                </span>
                H
                <span className="text-[#4d9041] group-hover:text-[#62a556]">
                  A
                </span>
                B
                <span className="text-[#4d9041] group-hover:text-[#62a556]">
                  U
                </span>
                L
              </h1>
              <img src="/reduced-logo.webp" alt="" className="w-15" />
            </Link>
          </h1>
        </div>

        {/* Hata Mesajı */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 tracking-tight">
          Erişim İzniniz Yok
        </h2>
        <p className="text-gray-600 mb-6 leading-relaxed">
          Üzgünüz, bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen giriş
          yapmayı deneyin veya ana sayfaya dönün.
        </p>

        {/* Ana Sayfaya Dön Düğmesi */}
        <Link to="/">
          <button className="w-full bg-[#6ca87e] text-white py-3 px-6 rounded-xl hover:bg-[#5b8f6b] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 cursor-pointer">
            Ana Sayfaya Dön
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AccessDenied;
